var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calculator-page"},[_c('calc-seo-intro',{attrs:{"path":"/calculators/corporate-dining"}}),_c('corporate-roi-calculator',{attrs:{"calculatorTitle":'Corporate Dining ROI'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }